import { Context as ReactContext, createContext, Dispatch, SetStateAction } from 'react';
import { app as microsoftTeamsApp} from '@microsoft/teams-js';
import { IHopexContext } from '../models/IHopexContext';

export interface IAppContext {
  hopexContext: IHopexContext | undefined;
    setHopexContext: Dispatch<SetStateAction<IHopexContext | undefined>>;
    teamsContext: microsoftTeamsApp.Context | undefined;
    setTeamsContext: Dispatch<SetStateAction<microsoftTeamsApp.Context | undefined>>;
}

const AppContext: ReactContext<IAppContext> = createContext({
  hopexContext: undefined,
  setHopexContext: () => undefined,
  teamsContext: undefined,
  setTeamsContext: () => undefined,
} as IAppContext);

export const AppContextProvider = AppContext.Provider;

export default AppContext;
